import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetRailColourOptions = (context: ProductBuilderMachineContext) => string[];

export const getRailColourOptions: GetRailColourOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { rail_colour },
  } = baseProduct;
  return rail_colour ? rail_colour : [];
};
